<template>
  <content-items-edit
    content-type="events"
    content-type-singular="event"
    content-name="Events"
    content-name-singular="Events"
  />
</template>

<script>
import ContentItemsEdit from '@/views/content-item/content-items-edit/ContentItemsEdit.vue'

export default {
  components: {
    ContentItemsEdit,
  },
}
</script>

<style scoped>

</style>
